import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  GovernanceGroupMembership,
  GovernanceGroupMembershipExtensionSchema,
  validateGovernanceGroupMembership,
} from './GovernanceGroupMembership';

export const AWSWorkloadGovernanceGroupMembershipFieldExtension =
  scaffolderPlugin.provide(
    createScaffolderFieldExtension({
      name: 'AWSWorkload_GovernanceGroupMembershipField',
      component: GovernanceGroupMembership,
      validation: validateGovernanceGroupMembership,
      schema: GovernanceGroupMembershipExtensionSchema,
    }),
  );
